import { useTranslate } from '@repo/shared/hooks'
import { z } from 'zod'

export const useWithdrawOnlinePaymentSchema = (balance: number) => {
  const { t } = useTranslate()
  const schema = z.object({
    card: z
      .string({
        required_error: t('withdrawOnlinePaymentPage_card_required'),
      })
      .min(1, { message: t('withdrawOnlinePaymentPage_card_required') }),
    amount: z
      .string({
        required_error: t('withdrawOnlinePaymentPage_amount_required'),
        invalid_type_error: t('withdrawOnlinePaymentPage_amount_invalid'),
      })
      .refine(
        (val) => {
          const parsed = parseFloat(val.replace(/,/g, ''))
          return !isNaN(parsed) && parsed >= 50_000
        },
        {
          message: t('withdrawOnlinePaymentPage_amount_min'),
        },
      )
      .refine(
        (val) => {
          const parsed = parseFloat(val.replace(/,/g, ''))
          return parsed <= balance
        },
        {
          message: t('withdrawOnlinePaymentPage_amount_max_balance'),
        },
      )
      .refine(
        (val) => {
          const parsed = parseFloat(val.replace(/,/g, ''))
          return parsed <= 100000000
        },
        {
          message: t('withdrawOnlinePaymentPage_amount_max'),
        },
      ),
  })
  return { schema }
}

export type WithdrawOnlinePaymentFormValues = z.infer<
  ReturnType<typeof useWithdrawOnlinePaymentSchema>['schema']
>
